
export default {
    head() {
        return {
            title: this.lesAtouts?.attributes?.metaTitle ? `${this.lesAtouts?.attributes?.metaTitle}` : `ICFA - Les atouts de l'aternance.` ,
            meta: this.lesAtouts?.attributes?.meta != null && this.lesAtouts?.attributes?.meta != undefined ?
                JSON.parse(this.lesAtouts?.attributes?.meta?.replace('\n', '')) : null
        };
        // return {
        //     title: `ICFA - Les atouts de l'aternance`,
        //     meta: [
        //         {
        //             hid: 'og-title',
        //             property: 'og:title',
        //             content: `Les atouts de l'aternance`,
        //         },
        //         // {
        //         //     hid: 'og-description',
        //         //     property: 'og:description',
        //         //     content: `Vous avez des questions sur nos formations en alternance? Contactez l'ICFA pour des conseils d'experts et des informations détaillées. Votre future carrière commence ici.`,
        //         // }
        //     ]
        // };
    },

    async asyncData({ params, $http, store }) {
        let instances = store.state.instances;

        const instance = instances.filter((instance) => {
            return instance.attributes.subFolderName == params.campusHP
        })[0];
        console.log(instance?.attributes?.global);

        if (!store.state.instance) {
            store.commit('setInstance', instance)
        }


        let lesAtouts = await $http.$get(`${process.env.strapiBaseUri}/api/les-atouts-principal`);
        lesAtouts = lesAtouts.data;


        return {
            instances, instance, lesAtouts
        }
    },
}
